<div class="api-token-form" data-testid="api-token-form">
    <form-item-text [subtitle]="labels.description"></form-item-text>

    <textarea class="api-token-field"
              readonly
              [value]="token"
              (click)="selectToken($event)"
              data-testid="api-token-value"></textarea>

    @if (copyMessage) {
        <div class="copy-message" data-testid="api-token-copy-message">
            {{ copyMessage }}
        </div>
    }

    <form-action-buttons>
        <form-button [subtitle]="labels.close"
                     [btnType]="'cancel'"
                     (click)="closeForm()">
        </form-button>
        <form-button [subtitle]="labels.copy"
                     [btnType]="'confirm'"
                     (click)="copyToken()">
        </form-button>
    </form-action-buttons>
</div>
